import { BaseQuestionObject } from "../frameworkObjects/BaseQuestionObject";

export class QuestionObject extends BaseQuestionObject {

};
